import React, { useState } from "react";
import Box from "@mui/material/Box";
import ImportedDataList from "./ImportedDataList";
import ImportedConfigFile from "./ImportedConfig";
import { Tab, Tabs, Typography } from "@mui/material";
import { t } from "i18next";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ImportedData() {
  const [selected, setSelected] = useState(0);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelected(newValue);
  };

  return (
    <Box>
      <Box>
        <Tabs value={selected} onChange={handleTabChange}>
          <Tab
            label={t("importdadaPage.importData", { ns: ["home"] })!}
            {...a11yProps(0)}
          />
          <Tab
            label={t("importdadaPage.importConfig", { ns: ["home"] })!}
            {...a11yProps(1)}
          />
        </Tabs>
      </Box>
      <TabPanel value={selected} index={0}>
        <ImportedDataList />
      </TabPanel>
      <TabPanel value={selected} index={1}>
        <ImportedConfigFile />
      </TabPanel>
    </Box>
  );
}
